import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";

import {
  BrowserRouter as Router,
  Navigate,
  Route,
  Routes,
} from "react-router-dom";

import HomePage from "pages/HomePage";
import Contact from "pages/Contact";
import Imprint from "pages/Imprint";

import Footer from "components/Footer";
import ScrollToTop from "components/ScrollToTop";
import Cookieconsent from "components/Cookieconsent";

const App = () => {
  return (
    <>
      <Router basename="">
        <Cookieconsent />
        <ScrollToTop>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/imprint" element={<Imprint />} />
            <Route path="*" element={<DefaultRoute />} />
          </Routes>
          <Footer />
        </ScrollToTop>
      </Router>
    </>
  );
};

const DefaultRoute: React.FC = (): React.ReactElement => {
  return <Navigate to={{ pathname: "/" }} />;
};

export default App;
